export default __webpack_public_path__ + "static/media/placeholder_business06-it-web.7c744323.png";